<template>
  <TraderDashboard v-if="store.getters.isTrader || store.getters.isTraderOperator"/>
  <MerchantDashboard v-if="store.getters.isMerchant || store.getters.isMerchantOperator"/>
  <div v-else>
  </div>
</template>
<script lang="ts">
import {defineComponent} from 'vue'
import {helper} from "@/service/CommonHelper";
import TraderDashboard from "@/apps/public/components/dashboard/TraderDashboard.vue";
import {useStore} from "vuex";
import MerchantDashboard from "@/apps/public/components/dashboard/MerchantDashboard.vue";

export default defineComponent({
  components: {
    TraderDashboard,
    MerchantDashboard
  },
  setup() {
    const store = useStore()

    return {
      store,
      helper,
    }
  }
})
</script>
